import { defineBoot } from '@quasar/app-vite/wrappers';
import ScanDialog from 'components/scanner/WebScanDialog.vue';

/**
 * Adds the web-scanner dialog (legacy).
 *
 * @param {{ app: import('vue').App }} params
 */
export default defineBoot(({ app }) => {
  app.component('ScanDialog', ScanDialog);
});
